'use strict';

var processInclude = require('base/util');
var util = require('app_custom_mufe/components/util');

$(document).ready(function () {
    processInclude(require('app_custom_mufe/product/detail'));
    processInclude(require('./product/updateProductAction'));
    processInclude(require('./product/grProductDetails'));

    // TODO: review this file and remove all unnecessary

    processInclude(require('./product/pdpPrimaryImages'));
    processInclude(require('./product/pdpPrimaryGallery'));
    processInclude(require('./product/reassuranceMessage'));
    processInclude(require('./product/howToSection'));
    processInclude(require('./components/alertOutOfStock'));
});

$(document).ready(function() {
    // Hide block shopping bag step number on page cart and mobile device.
    if (util.isMobile()){
        $('.receipt .block-shopping-bag').addClass('hidden-md-down');
    }
    var toasterDisplay = localStorage.getItem('toasterBanner');
    var $closeButton = document.getElementById("close-button");
    if ($closeButton) {
        if (toasterDisplay === null) {
            $closeButton.style.display = "flex";
        } else {
            $closeButton.style.display = "none";
        }
    }

    $('.main_toaster_close').click(function () {
        if ($closeButton) {
            $closeButton.style.display = "none";
            localStorage.setItem('toasterBanner', 'test');
        }
    });

    $(document).on('change', '.sample-check', function () {
        var sampleId = $(this).attr("data-id");
        var sampleImage = $(this).parent().find('.sample-element-img img').attr('src');
        var sampleName = $(this).parent().find('.line-item-name').text();
        var sampleDetailColor = $(this).parent().find(" span[data-attr='color']").html() ? $(this).parent().find(" span[data-attr='color']").html() : "";
        var sampleDetailSize = $(this).parent().find(" span[data-attr='CORECAPACITY']").text();
        var sampleDetailShadeTitle = $(this).parent().find(".title-shade").text();
        var freePrice = $("#cart-sample-price" ).val();

        if (this.checked) {
            localStorage.setItem('sample',sampleName);
            $("#productlist-cart").append(
                '<li class="card product-info cart-element cart-element-sample added-sample" data-id='+sampleId+'>'+
                '<div class="row">'+
                    '<div id="cart-element-img"> <img class="product-image" src='+ sampleImage.replace(/ /g,'%20') + '  /></div>'+
                    '<div class="cart-element-content">'+
                        '<div class="line-item-header">'+
                            '<div class="line-item-name">'+sampleName+'</div>'+
                            '<div class="line-item-total-price bonus-product-item-price">'+
                            '<div class="bonus-product-bloc">'+
                            '<div class="bonus-produc-bloc-icon"><span class="icon-GIFT---SMALL"></span></div>'+
                            '<div class="bonus-produc-bloc-text">'+freePrice+'</div> '+
                            '</div>'+
                        '</div>'+
                        '</div>'+
                        '<div id="cart-element-attributes">'+
                            '<p class="line-item-attributes "><strong>'+sampleDetailShadeTitle+'</strong>'+sampleDetailColor+'</p>'+
                            '<p class="line-item-attributes ">'+sampleDetailSize+'</p>'+
                        '</div>'+
                    '</div>'+
                '</div>'+
                '</li>'
            );
        } else {
            $(".cart-element-sample").each(function() {
                if ($(this).attr("data-id") == sampleId) {
                    $(this).remove();
                }
            })
        }
    });
});


$('.quantity-changeable .quantity-button, .quantity-sticky .quantity-button').on('click', function () {
    var newVal, maxValue, oldValue;
    var pid = ($(this).attr("data-pid"));
    var traductionText = $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').data('text');

    if (!pid) {
        oldValue = $(".quantity-changeable #quantity option:selected").text();
        maxValue = parseInt($('.quantity-changeable #quantity option:last').val());

        if (this.id == "quantity-plus") {
            newVal = parseFloat(oldValue) + 1;
            if ($(".quantity-sticky").length > 0) {
                $(".quantity-sticky #quantity option[value='"+newVal+"']").prop('selected', true);
                $(".quantity-sticky #quantity option[value='"+newVal+"']").text(newVal);
                $('.quantity-sticky #quantity-minus').prop('disabled', false);
                if (oldValue >= maxValue - 1) {
                    $('.quantity-sticky #quantity-plus').prop('disabled', true);
                }
            }
            $(".quantity-changeable #quantity option[value='"+newVal+"']").prop('selected', true);
            $(".quantity-changeable #quantity option[value='"+newVal+"']").text(newVal);
            $('.quantity-changeable #quantity-minus').prop('disabled', false);
            if (oldValue >= maxValue - 1) {
                $('.quantity-changeable #quantity-plus').prop('disabled', true);
            }
        } else {
            if (oldValue > 0) {
                newVal = parseFloat(oldValue) - 1;
                if ($(".quantity-sticky").length > 0) {
                    $(".quantity-sticky #quantity option[value='"+newVal+"']").prop('selected', true);
                    $(".quantity-sticky #quantity option[value='"+newVal+"']").text(newVal);
                    $('.quantity-sticky #quantity-plus').prop('disabled', false);
                    if (oldValue <= 2) {
                        $('.quantity-sticky #quantity-minus').prop('disabled', true);
                    }
                }
                $(".quantity-changeable #quantity option[value='"+newVal+"']").prop('selected', true);
                $(".quantity-changeable #quantity option[value='"+newVal+"']").text(newVal);
                $('.quantity-changeable #quantity-plus').prop('disabled', false);
                if (oldValue <= 2) {
                    $('.quantity-changeable #quantity-minus').prop('disabled', true);
                }
            } else {
                newVal = 0;
            }
        }
        $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
    } else {
        pid = ($(this).attr("data-pid"));
        oldValue = parseInt($('.quantity-changeable .quantity[data-pid='+pid+'] option:selected').text());
        maxValue = parseInt($('.quantity-changeable .quantity[data-pid='+pid+'] option:last').val());

        if (this.id === 'quantity-plus') {
            newVal = parseFloat(oldValue) + 1;
            $(".quantity-changeable .quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
            $(".quantity-changeable .quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
            $('.quantity-changeable #quantity-minus[data-pid='+pid+']').prop('disabled', false);
            if (oldValue >= maxValue) {
                $('.quantity-changeable #quantity-plus[data-pid='+pid+']').prop('disabled', true);
            }
        } else {
            if (oldValue > 0) {
                newVal = parseFloat(oldValue) - 1;
                $(".quantity-changeable .quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
                $(".quantity-changeable .quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
                $('.quantity-changeable #quantity-plus[data-pid='+pid+']').prop('disabled', false);
                if (oldValue <= 2) {
                    $('.quantity-changeable #quantity-minus[data-pid='+pid+']').prop('disabled', true);
                }
            } else {
                newVal = 0;
            }
        }
        $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
    }
});

$(document).ready(function () {
    var windowSize = $(window).width();
    var $klarnaPdp = $(".klarna-pdp");
    if ($klarnaPdp.length) {
        if ($(".attribute.attribute-selector").length) {
            $klarnaPdp.css("margin-bottom", "-80px");
        } else {
            $klarnaPdp.css("margin-bottom", "10px");
        }

        if ($(".strike-price").text() !== "") {
            $klarnaPdp.css("margin-top", "80px");
        }
    }

    if (windowSize < 960) {
        $('#ingredients').addClass('collapse');
        $('#description').addClass('collapse');
        $('.cookie-bar, .optanon-alert-box-wrapper').addClass('cookie-bar-mobile');

        $(window).scroll(function() {
            var hT = $('.footer-content-1').offset() ? $('.footer-content-1').offset().top : "",
                hH = $('.footer-content-1').outerHeight(),
                wH = $(window).height(),
                wS = $(this).scrollTop();
            if (wS > (hT+hH-wH)) {
                $('.add-to-cart__text').hide();
                $('.mobilePrice').hide();
                $('.cookie-bar, .optanon-alert-box-wrapper').removeClass('cookie-bar-mobile');
            } else {
                $('.add-to-cart__text').show();
                $('.mobilePrice').show();
                $('.cookie-bar, .optanon-alert-box-wrapper').addClass('cookie-bar-mobile');
            }
        });
    }
    setTimeout(function () {
        $('.color-swatchs-palette-container .shade-selector-button.active').trigger('loaderstart');
    }, 300);
});
